import {__} from "@wordpress/i18n";

export default function TieredPricingOption({attributes, quantity, discount, price, isSelected}) {

    let blockStyle = {}

    if (isSelected) {
        blockStyle.borderColor = attributes.activeTierColor;
        blockStyle.background = hexToRgbA(attributes.activeTierColor, 0.05);
    }

    return (
        <div className={isSelected ? 'tiered-pricing-option tiered-pricing--active' : 'tiered-pricing-option'}
             style={blockStyle}>

            <div className="tiered-pricing-option__checkbox">
                <div
                    className={isSelected ? 'tiered-pricing-option-checkbox tiered-pricing-option-checkbox--active' : 'tiered-pricing-option-checkbox'}>
                </div>
            </div>

            <div className="tiered-pricing-option__quantity">
                <strong>{quantity}</strong> {__('pieces', 'tier-pricing-table')}
            </div>

            <div className="tiered-pricing-option__pricing">
                <div className="tiered-pricing-option-price">
                    <div className="tiered-pricing-option-price__discounted">
                        <span className="woocommerce-Price-amount amount">
                            <span className="woocommerce-Price-currencySymbol">$</span>{price}.00
                        </span>
                    </div>
                </div>
                <div className="tiered-pricing-option-total">
                    <div className="tiered-pricing-option-total__label">
                        Total:
                    </div>
                    <div className="tiered-pricing-option-total__discounted_total">
                        <span className="woocommerce-Price-amount amount">
                            <span className="woocommerce-Price-currencySymbol">$</span>{price}.00</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

function hexToRgbA(hex, opacity = 1) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
    }
    return '';
}